module.exports = __webpack_public_path__ + "static/media/sync.996c1da4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/sync.png
// module id = 1492
// module chunks = 39